import http from "../../httpService";
import { apiUrl } from "../../../../config.js";

const apiEndpoint = apiUrl + "/setup/user/";

export function getDepartments() {
  return http.get(apiEndpoint + "departments");
}

export function saveDepartment(department) {
  return httpSaveData("department", department);
}

export function deleteDepartment(departmentID) {
  return http.delete(apiEndpoint + "department/" + departmentID);
}

export function getDivisions() {
  return http.get(apiEndpoint + "divisions");
}

export function saveDivision(division) {
  return httpSaveData("division", division);
}

export function deleteDivision(divisionID) {
  return http.delete(apiEndpoint + "division/" + divisionID);
}

export function getOfficeLocations() {
  return http.get(apiEndpoint + "office-locations");
}

export function saveOfficeLocation(officeLocation) {
  return httpSaveData("office-location", officeLocation);
}

export function deleteOfficeLocation(officeLocationID) {
  return http.delete(apiEndpoint + "office-location/" + officeLocationID);
}

export function getTaskStatus() {
  return http.get(apiEndpoint + "task-status");
}

export function saveTaskStatus(taskStatus) {
  return httpSaveData("task-status", taskStatus);
}

export function deleteTaskStatus(taskStatusID) {
  return http.delete(apiEndpoint + "task-status/" + taskStatusID);
}

export function saveTaskStatusOrder(taskStatus = []) {
  return http.put(apiEndpoint + "task-status-order", taskStatus);
}

function httpSaveData(path, data) {
  if (data.ID === 0) {
    return http.post(apiEndpoint + path, data);
  } else {
    return http.put(apiEndpoint + path, data);
  }
}
